import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import DownIcon from '../../../assets/icons/arrow-down.svg'

import styles from './select.css'

const Select = ({ onChange, options, error, selected, placeholder }) => (
  <div styleName="container">
    <select
      styleName={error ? 'select-error' : 'select-normal'}
      value={selected}
      onChange={onChange}
    >
      {placeholder && <option value="placeholder" disabled>{placeholder}</option>}
      {options && options.map((option, i) => (
        <option key={i} value={option.value}>{option.label}</option>
      ))}
    </select>
    <DownIcon styleName="arrow" />
  </div>
)

Select.propTypes = {
  error: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  selected: PropTypes.string,
}

export default CSSModules(Select, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/select/select.js
 **/